import React from 'react';
import { FiX, FiCheck } from 'react-icons/fi';
import IconWrapper from '../../../IconWrapper';
import { TaxonomyLabelProps } from './types';
import LabelTooltip from './LabelTooltip';

const TaxonomyLabel: React.FC<TaxonomyLabelProps> = ({ 
  label, 
  isIncorrect, 
  onToggleIncorrect,
  color 
}) => {
  
  return (
    <LabelTooltip label={label}>
      <div 
        className={`
          inline-flex items-center gap-2 px-3 py-1.5 rounded-full text-sm
          transition-all duration-200 cursor-pointer select-none
          ${isIncorrect 
            ? `bg-gray-100 text-gray-500 line-through opacity-75` 
            : `${color} hover:opacity-90`
          }
        `}
        onClick={onToggleIncorrect}
      >
        <IconWrapper 
          icon={isIncorrect ? FiX : FiCheck} 
          className={`h-3.5 w-3.5 ${isIncorrect ? 'text-gray-400' : ''}`} 
        />
        <span className="font-medium">
          {label.label_name.split('_').map(word => 
            word.charAt(0).toUpperCase() + word.slice(1)
          ).join(' ')}
        </span>
        <span className={`text-xs ${isIncorrect ? 'text-gray-400' : 'opacity-75'}`}>
          {Math.round(label.confidence * 100)}%
        </span>
        <button
          onClick={(e) => {
            e.stopPropagation();
            onToggleIncorrect();
          }}
          className={`
            ml-1 opacity-0 group-hover:opacity-100 transition-opacity duration-200
            hover:bg-black hover:bg-opacity-10 rounded-full p-0.5
          `}
          aria-label={isIncorrect ? "Mark as correct" : "Mark as incorrect"}
        >
          <IconWrapper 
            icon={FiX} 
            className="h-3 w-3" 
          />
        </button>
      </div>
    </LabelTooltip>
  );
};

export default TaxonomyLabel;